export default {
  CASH: 'cash',
  BANK_TRANSFER: 'bank_transfer',
  ONLINE_PAYMENT: 'online_payment',
}
